import { Injectable } from '@angular/core';
import { AppSettings } from '../enums/app-settings.enum';
import { UtilitiesService } from '../utilities/utilities.service';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root',
})
export class AdobeAnalyticsService {
  private currency = AppSettings.LOCAL_CURRENTCY;
  private previousPageName: string = '';
  constructor(private UTS: UtilitiesService, private urlService: UrlService) {
    this.urlService.previousUrl$.subscribe((previousUrl: string) => {
      this.previousPageName = previousUrl;
    });
  }

  getPlanType(item: any) {
    let _type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return (_type = 'New control line' + ' ' + item?.displayName);
    else if (
      item?.productType == 'MOBILE_POSTPAID' ||
      item?.commerceItemType == 'etsElifeSku'
    )
      return (_type = item.displayName);
    else if (item?.productType == 'MOBILE_PREPAID')
      return (_type = item.displayName + 'Prepaid Line');
    else return (_type = item?.displayName);
  }

  getProductType(item: any) {
    let _type;
    if (item?.productType == 'MOBILE_CONTROLLINE') return (_type = 'plan');
    else if (
      item?.productType == 'MOBILE_POSTPAID' ||
      item?.commerceItemType == 'etsElifeSku'
    )
      return (_type = 'plan');
    else if (item?.productType == 'MOBILE_PREPAID') return (_type = 'plan');
    else return (_type = 'device');
  }

  getItemCatType(item: any) {
    let type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return (type = item?.commerceItemCategory);
    else if (item?.productType == 'MOBILE_POSTPAID')
      return (type = item?.landingFrom);
    else if (item?.productType == 'MOBILE_PREPAID')
      return (type = 'Prepaid_plan');
    else if (item?.commerceItemType == 'etsElifeSku')
      return (type = 'eLife_plan');
    else return (type = item?.commerceItemCategory);
  }

  getSpecs(cart: any, specType: any) {
    if (cart && cart.specifications && cart.specifications.length > 0) {
      let data = cart.specifications;
      for (let i = 0; i < data.length; i++) {
        if (data[i].type.toLowerCase() == specType) {
          return data[i].name;
        }
      }
      return '';
    }
  }

  addFilterApplyEvent(category: string, type: string, value: string) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          event: 'filter',
          filterDetails: {
            filterCategory: category,
            filterType: type,
            filterValue: value,
          },
          eventInfo: {
            filterClick: 1,
          },
        });
      }
    } catch (e) {
      this.UTS.error(e);
      console.error(e);
    }
  }

  addLinkCTAEvent(
    name: string,
    type: string,
    region: string,
    sectionHeading: string,
    action: string,
    linkName: any = null
  ) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          event: 'linkClicked',
          xdmActionDetails: {
            web: {
              webInteraction: {
                name: name,
                URL: window.location.href,
                type: type,
                region: region,
                linkClicks: {
                  value: 1,
                },
              },
            },
            linkInfo: {
              sectionHeading: sectionHeading,
              action: action,
              name: linkName == null ? name : linkName,
            },
          },
        });
      }
    } catch (e) {
      this.UTS.error(e);
      console.error(e);
    }
  }

  addBuyNowCTAEvent(
    name: string,
    type: string,
    region: string,
    sectionHeading: string,
    action: string,
    productName: string,
    price: string,
    productType: string,
    productCategory: string,
    productDescription: string
  ) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          event: 'linkClicked',
          xdmActionDetails: {
            web: {
              webInteraction: {
                name: name,
                URL: window.location.href,
                type: type,
                region: region,
                linkClicks: {
                  value: 1,
                },
              },
            },
            linkInfo: {
              sectionHeading: sectionHeading,
              action: action,
              name: name,
            },
            product: {
              productDetails: {
                productName: productName,
                productPrice: price,
                productType: productType,
                productCategory: productCategory,
                productDescription: productDescription.replace(/<[^>]*>/g, ''),
              },
            },
          },
        });
      }
    } catch (e) {
      this.UTS.error(e);
      console.error(e);
    }
  }

  pageLoadedEvent(
    pageName: string,
    section: string,
    error: boolean,
    eventInfo = null
  ) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          event: 'pageLoaded',
          xdmPageLoad: {
            web: {
              webPageDetails: {
                name:
                  (localStorage.getItem('language')
                    ? (localStorage.getItem('language') == 'en' ? 'en' : 'ar')
                    : 'en') +
                  '-ae:' +
                  pageName, //Ex:en-ae:home
                server: window.location.host,
                siteSection: section,
                siteSection1: 'Home Navigation',
                siteSection2: '',
                siteSection3: '',
                isErrorPage: error,
                URL: window.location.href,
                pageViews: {
                  value: 1,
                },
              },
            },
            pageInfo: {
              country: 'ae',
              language: localStorage.getItem('language')
                ? (localStorage.getItem('language') == 'en' ? 'en' : 'ar')
                : 'en',
              previousPageName: this.previousPageName
                ? this.previousPageName
                : '',
              pageType: section,
              pageLoadTime: Math.floor(performance.now() / 1000),
            },
            user: {
              loginStatus: sessionStorage.getItem('isLoggedIn') == 'true'
                ? 'logged-in'
                : 'logged-out',
              customerId: sessionStorage.getItem('userId')
                ? sessionStorage.getItem('userId')
                : '',
              customerType: "",
            },
            timestamp: Date.now(),
            userAgentString: navigator.userAgent,
          },
          eventInfo: eventInfo,
        });
      }
    } catch (e) {
      this.UTS.error(e);
      console.error(e);
    }
  }

  addCheckNumberAvailabilityCTAEvent(
    name: string,
    region: string,
    sectionHeading: string,
    action: string,
    digits: number,
    stdCode: string
  ) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          event: 'linkClicked',
          xdmActionDetails: {
            web: {
              webInteraction: {
                name: name,
                URL: window.location.href,
                type: 'other',
                region: region,
                linkClicks: {
                  value: 1,
                },
              },
            },
            linkInfo: {
              sectionHeading: sectionHeading,
              action: action,
              name: name,
            },
            user: {
              favioriteNumberDigits: digits,
              stdCode: stdCode,
            },
          },
        });
      }
    } catch (e) {
      this.UTS.error(e);
      console.error(e);
    }
  }

  addToCartEvent(
    name: string,
    region: string,
    sectionHeading: string,
    action: string,
    product: any,
    productType: string,
    productCategory: string,
    productDescription: string
  ) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push({
          event: 'linkClicked',
          xdmActionDetails: {
            web: {
              webInteraction: {
                name: name,
                URL: window.location.href,
                type: 'other',
                region: region,
                linkClicks: {
                  value: 1,
                },
              },
            },
            linkInfo: {
              sectionHeading: sectionHeading,
              action: action,
              name: name,
            },
            product: {
              productDetails: {
                productName: product.productName,
                productPrice: product.planSkus[0].listPrice,
                productType: productType,
                productCategory: productCategory,
                productDescription: productDescription.replace(/<[^>]*>/g, ''),
                productQuantity: product.quantity,
                contract: product.planSkus[0].contractDuration,
              },
            },
            eventInfo: {
              cartAdd: 1,
            },
          },
        });
      }
    } catch (e) {
      this.UTS.error(e);
    }
  }

  pageErrorEvent(
    pageName: string,
    section: string,
    errorMessage: string,
    errorCode: string,
    apiError: boolean
  ) {
    try {
      if (window.adobeDataLayer) {
        //Setting only Page Level variables on page loading complete
        window.adobeDataLayer.push({
          event: 'errorInteraction',
          xdmActionDetails: {
            errorInfo: {
              error: 1,
              errorMessage: errorMessage, // Incorrect otp
              errorCode: errorCode, // error code
              errorType: apiError ? 'API error' : 'Validation error', //validation error/API Error
            },
          }
        });
      }
    } catch (e) {
      this.UTS.error(e);
      this.UTS.log(e);
    }
  }

  cartLoadEvent(
    pageName: string,
    section: string,
    error: boolean,
    cart: any,
    total: any
  ) {
    let items = [];
    if (cart && cart.items && cart.items.length > 0) {
      for (let i = 0; i < cart.items.length; i++) {
        const storage = cart.items[i].specifications?.filter(e => e.type === 'Storage');
        const colour = cart.items[i].specifications?.filter(e => e.type === 'Colour');
        items.push({
          "name": this.getPlanType(cart.items[i]) || '',
          "priceTotal": (cart.items[i] && cart.items[i].paymentOptions && cart.items[i].paymentOptions.price) ? cart.items[i].paymentOptions.price : (cart.items[i].price.oneTime) ? cart.items[i].price.oneTime : 0.0,		// Double
          "quantity": cart.items[i].quantity || 0,		// Integer
          "_merchVars": {
            "productType": this.getProductType(cart.items[i]) || '',
            "productCategory": this.getItemCatType(cart.items[i]) || '',
            "productSubCategory1": '',
            "price": (cart.items[i] && cart.items[i].paymentOptions && cart.items[i].paymentOptions.price) ? cart.items[i].paymentOptions.price : (cart.items[i].price.oneTime) ? cart.items[i].price.oneTime : 0.0,		// Double
            "contractPeriod": cart.items[i].contractDuration || "",
            "contractType": cart.items[i].contractDuration == '12-month commitment' ? 'Monthly' : '',
            "deviceBrand": cart.items[i].brand || '',
            "deviceStorage": storage?.length > 0 ? storage[0].name : '',
            "deviceMemory": '',
            "deviceColor": colour?.length > 0 ? colour[0].name : '',
            "deviceScreenSize": "",
            "deviceOperatingSystem": "",
            "deviceModelYear": ""
          }
        })
      }
    }

    try {
      if (window.adobeDataLayer && cart) {
        window.adobeDataLayer.push({
          event: 'cart-page',
          xdmPageLoad: {
            web: {
              webPageDetails: {
                name:
                  (localStorage.getItem('language')
                    ? (localStorage.getItem('language') == 'en' ? 'en' : 'ar')
                    : 'en') +
                  '-ae:' +
                  pageName, //Ex:en-ae:home
                server: window.location.host,
                siteSection: section,
                siteSection1: 'Home Navigation',
                siteSection2: '',
                siteSection3: '',
                isErrorPage: error,
                URL: window.location.href,
                pageViews: {
                  value: 1,
                },
              },
            },
            pageInfo: {
              country: 'ae',
              language: localStorage.getItem('language')
                ? (localStorage.getItem('language') == 'en' ? 'en' : 'ar')
                : 'en',
              previousPageName: document.referrer,
              pageType: 'shopping cart',
              pageLoadTime: Math.floor(performance.now() / 1000),
            },
            user: {
              loginStatus: sessionStorage.getItem('isLoggedIn') == 'true'
                ? 'logged-in'
                : 'logged-out',
              customerId: sessionStorage.getItem('userId')
                ? sessionStorage.getItem('userId')
                : '',
              customerType: "",
            },
            timestamp: Date.now(),
            userAgentString: navigator.userAgent,
            productListItems: items,
            numberOfItems: items.length,
            cartValue: total,
            commerce: {
              productListViews: {
                value: 1,
              }
            },
          },
        });
      }
    } catch (e) {
      this.UTS.error(e);
      this.UTS.log(e);
    }
  }

  addProceedToCheckoutCTAEvent(
    name: string,
    region: string,
    sectionHeading: string,
    action: string,
    cart: any
  ) {
    let items = [];
    if (cart && cart.items && cart.items.length > 0) {
      for (let i = 0; i < cart.items.length; i++) {
        const storage = cart.items[i].specifications?.filter(e => e.type === 'Storage');
        const colour = cart.items[i].specifications?.filter(e => e.type === 'Colour');
        items.push({
          "name": this.getPlanType(cart.items[i]) || '',
          "priceTotal": (cart.items[i] && cart.items[i].paymentOptions && cart.items[i].paymentOptions.price) ? cart.items[i].paymentOptions.price : (cart.items[i].price.oneTime) ? cart.items[i].price.oneTime : 0.0,		// Double
          "quantity": cart.items[i].quantity || 0,		// Integer
          "_merchVars": {
            "productType": this.getProductType(cart.items[i]) || '',
            "productCategory": this.getItemCatType(cart.items[i]) || '',
            "productSubCategory1": '',
            "price": (cart.items[i] && cart.items[i].paymentOptions && cart.items[i].paymentOptions.price) ? cart.items[i].paymentOptions.price : (cart.items[i].price.oneTime) ? cart.items[i].price.oneTime : 0.0,		// Double
            "contractPeriod": cart.items[i].contractDuration || "",
            "contractType": cart.items[i].contractDuration == '12-month commitment' ? 'Monthly' : '',
            "deviceBrand": cart.items[i].brand || '',
            "deviceStorage": storage?.length > 0 ? storage[0].name : '',
            "deviceMemory": '',
            "deviceColor": colour?.length > 0 ? colour[0].name : '',
            "deviceScreenSize": "",
            "deviceOperatingSystem": "",
            "deviceModelYear": ""
          }
        })
      }
    }
    localStorage.setItem('adobeAnalyticsProductListItems', JSON.stringify(items))
    try {
      if (window.adobeDataLayer && cart) {
        window.adobeDataLayer.push({
          "event": "checkout",
          "xdmActionDetails": {
            "web": {
              "webInteraction": {
                "name": name,
                "URL": window.location.href,
                "type": "other",
                "region": region,
                "linkClicks": {
                  "value": 1
                }
              }
            },
            linkInfo: {
              sectionHeading: sessionStorage.getItem('productSectionHeading') ? sessionStorage.getItem('productSectionHeading') : '',
              action: action,
              name: name,
            },
            productListItems: items,
            commerce: {
              checkouts: {
                value: 1
              }
            },
          }
        })
      }
    } catch (e) {
      this.UTS.error(e);
      this.UTS.log(e);
    }
    this.UTS.log(window.adobeDataLayer);
  }

  // addProceedToCheckoutCTAEvent(name: string, region: string, sectionHeading: string, action: string, cart: any) {
  //   console.log('cle', cart)
  //   let items = [];
  //   if (cart && cart.items && cart.items.length > 0) {
  //     for (let i = 0; i < cart.items.length; i++) {
  //       items.push({
  //         "productDetails": {
  //           "productName": this.getPlanType(cart.items[i]) || '',
  //           "productPrice": (cart.items[i] && cart.items[i].paymentOptions && cart.items[i].paymentOptions.price) ? cart.items[i].paymentOptions.price : (cart.items[i].price.oneTime) ? cart.items[i].price.oneTime : '',
  //           "productType": this.getProductType(cart.items[i]) || '',
  //           "productColor": this.getSpecs(cart.items[i], 'colour') || "",
  //           "productCategory": this.getItemCatType(cart.items[i]) || '',
  //           "productDescription": (cart.items[i].displayName) || '',
  //           "productQuantity": cart.items[i].quantity || '',
  //         }
  //       })
  //     }
  //   }

  //   try {
  //     if (window.adobeDataLayer && cart) {
  //       window.adobeDataLayer.push({
  //         "event": "linkClicked",
  //         "xdmActionDetails": {
  //           "web": {
  //             "webInteraction": {
  //               "name": name,
  //               "URL": window.location.href,
  //               "type": "other",
  //               "region": region,
  //               "linkClicks": {
  //                 "value": 1
  //               }
  //             }
  //           },
  //           "linkInfo": {
  //             "sectionHeading": sectionHeading,
  //             "action": action,
  //             "name": name
  //           },
  //           "product": {
  //             "productDetails": items.length > 1 ? items : items[0],
  //           },
  //           "eventInfo": {
  //             "checkout": 1
  //           }
  //         }
  //       })
  //     }
  //   } catch (e) {
  //     this.UTS.error(e)
  //     console.log(e);
  //   }
  //   console.log(window.adobeDataLayer);
  // };

  cartRemoveEvent(name: string, region: string, sectionHeading: string, action: string, cart: any) {
    console.log('cle', cart)
    let items = [];
    if (cart && cart.items && cart.items.length > 0) {
      for (let i = 0; i < cart.items.length; i++) {
        items.push({
          productDetails: {
            productName: this.getPlanType(cart.items[i]) || '',
            productPrice:
              cart.items[i] &&
                cart.items[i].paymentOptions &&
                cart.items[i].paymentOptions.price
                ? cart.items[i].paymentOptions.price
                : cart.items[i].price.oneTime
                  ? cart.items[i].price.oneTime
                  : '',
            productType: this.getProductType(cart.items[i]) || '',
            productColor: this.getSpecs(cart.items[i], 'colour') || '',
            productCategory: this.getItemCatType(cart.items[i]) || '',
            productDescription: cart.items[i].displayName || '',
            productQuantity: cart.items[i].quantity || '',
            contract: cart.items[i].contractDuration || '',
          },
        });
      }
    }

    if (window.adobeDataLayer && cart) {
      try {
        window.adobeDataLayer.push({
          event: 'linkClicked',
          xdmActionDetails: {
            web: {
              webInteraction: {
                name: name,
                URL: window.location.href,
                type: 'other',
                region: region,
                linkClicks: {
                  value: 1,
                },
              },
            },
            linkInfo: {
              sectionHeading: sectionHeading,
              action: action,
              name: name,
            },
            product: {
              productDetails: items[0],
            },
            eventInfo: {
              cartRemove: 1,
            },
          },
        });
      } catch (e) {
        this.UTS.error(e);
        this.UTS.log(e);
      }
    }
  }

  personalInfoBuyNowCTAEvent(
    name: string,
    type: string,
    region: string,
    sectionHeading: string,
    action: string,
    userInfo: any
  ) {
    if (window.adobeDataLayer) {
      try {
        window.adobeDataLayer.push({
          event: 'linkClicked',
          xdmActionDetails: {
            web: {
              webInteraction: {
                name: name,
                URL: window.location.href,
                type: type,
                region: region,
                linkClicks: {
                  value: 1,
                },
              },
            },
            linkInfo: {
              sectionHeading: sessionStorage.getItem('productSectionHeading') ? sessionStorage.getItem('productSectionHeading') : '',
              action: action,
              name: name,
            },
            user: {
              customerId: sessionStorage.getItem('userId')
                ? sessionStorage.getItem('userId')
                : '',
            },
          },
        });
      } catch (e) {
        this.UTS.error(e);
        this.UTS.log(e);
      }
    }
  }

  paymentMethodBuyNowCTAEvent(
    name: string,
    type: string,
    region: string,
    sectionHeading: string,
    action: string,
    paymentSubMethod: string,
    transactionAmount: String
  ) {
    if (window.adobeDataLayer) {
      try {
        window.adobeDataLayer.push({
          event: 'linkClicked',
          xdmActionDetails: {
            web: {
              webInteraction: {
                name: name,
                URL: window.location.href,
                type: type,
                region: region,
                linkClicks: {
                  value: 1,
                },
              },
            },
            linkInfo: {
              sectionHeading: sessionStorage.getItem('productSectionHeading') ? sessionStorage.getItem('productSectionHeading') : '',
              action: action,
              name: name,
            },
            product: {
              transactionAmount: transactionAmount,
              paymentMethod: paymentSubMethod == "cashOnDelivery" ? "pay offline" : "pay online",
              paymentSubMethod: paymentSubMethod,
            },
            eventInfo: {
              paymentContinue: 1
            }
          },
        });
      } catch (e) {
        this.UTS.error(e);
        this.UTS.log(e);
      }
    }
  }

  orderSuccessEvent(orderId: string, total: string, cart: any) {
    console.log('cle', cart)
    const items = JSON.parse(localStorage.getItem("adobeAnalyticsProductListItems"));
    const epgTransactionId = localStorage.getItem("epgTransactionId");
    const paymentMethod = localStorage.getItem("paymentMethod");
    const commerce = {
      "purchases": {
        "value": 1
      },
      "order": {
        "purchaseID": orderId,
        "currencyCode": "AED",
        "priceTotal": total,	// Double
        "payments": [{
          "transactionID": epgTransactionId ? epgTransactionId : '',
          "paymentAmount": total ? total : '',		// Double
          "paymentType": paymentMethod ? paymentMethod : '',
          "currencyCode": "AED"
        }]
      }

    }

    try {
      if (window.adobeDataLayer && cart) {
        window.adobeDataLayer.push({
          "event": "order-confirmation",
          "xdmPageLoad": {
            "web": {
              "webPageDetails": {
                "name": "Payment method",  //Ex:en-ae:order confirmation page
                "server": window.location.host,	 //Ex: www.etisalat.ae
                "siteSection": "Order Confirmation",	    //Ex: order confirmation
                "siteSection1": "home navigation",   //Ex:
                "siteSection2": "",  // Ex:
                "siteSection3": "",
                "isErrorPage": "false",
                "URL": window.location.href,
                "pageViews": {
                  "value": 1
                }
              }
            },
            pageInfo: {
              country: 'ae',
              language: localStorage.getItem('language')
                ? (localStorage.getItem('language') == 'en' ? 'en' : 'ar')
                : 'en',
              previousPageName: document.referrer,
              pageType: 'Home',
              pageLoadTime: Math.floor(performance.now() / 1000),
            },
            user: {
              loginStatus: sessionStorage.getItem('isLoggedIn') == 'true'
                ? 'logged-in'
                : 'logged-out',
              customerId: sessionStorage.getItem('userId')
                ? sessionStorage.getItem('userId')
                : '',
              customerType: "",
              orderId: orderId,
            },
            timestamp: Date.now(),
            userAgentString: navigator.userAgent,
            "productListItems": items ? items : '',
            "commerce": commerce,
          }
        });
      }
    } catch (e) {
      this.UTS.error(e);
      this.UTS.log(e);
    }
  }

  // orderSuccessEvent(orderId: string, total: string, cart: any) {
  //   console.log('cle', cart)
  //   let items = [];
  //   if (cart && cart.items && cart.items.length > 0) {
  //     for (let i = 0; i < cart.items.length; i++) {
  //       items.push({
  //         "productDetails": {
  //           "productName": this.getPlanType(cart.items[i]) || '',
  //           "productPrice": (cart.items[i] && cart.items[i].paymentOptions && cart.items[i].paymentOptions.price) ? cart.items[i].paymentOptions.price : (cart.items[i].price.oneTime) ? cart.items[i].price.oneTime : '',
  //           "productType": this.getProductType(cart.items[i]) || '',
  //           "productColor": this.getSpecs(cart.items[i], 'colour') || "",
  //           "productCategory": this.getItemCatType(cart.items[i]) || '',
  //           "productDescription": (cart.items[i].displayName) || '',
  //           "productQuantity": cart.items[i].quantity || '',
  //           "contract": cart.items[i].contractDuration || '',
  //         }
  //       })
  //     }
  //   }

  //   try {
  //     if (window.adobeDataLayer && cart) {

  //       window.adobeDataLayer.push({
  //         "event": "pageLoaded",
  //         "xdmPageLoad": {
  //           "web": {
  //             "webPageDetails": {
  //               "name": "Payment method",  //Ex:en-ae:order confirmation page
  //               "server": window.location.host,	 //Ex: www.etisalat.ae
  //               "siteSection": "Order Confirmation",	    //Ex: order confirmation
  //               "siteSection1": "home navigation",   //Ex:
  //               "siteSection2": "",  // Ex:
  //               "siteSection3": "",
  //               "isErrorPage": "false",
  //               "URL": window.location.href,
  //               "pageViews": {
  //                 "value": 1
  //               }
  //             }
  //           },
  //           "pageInfo": {
  //             "country": "ae",
  //             "language": localStorage.getItem('language') ? (localStorage.getItem('language') == 'en' ? 'en': 'ar') : 'en',
  //             "previousPageName": document.referrer,
  //             "pageType": "Home",
  //             "pageLoadTime": Math.floor(performance.now() / 1000)
  //           },
  //           "user": {
  //             "loginStatus": sessionStorage.getItem("isLoggedIn") ? "logged-in" : "logged-out",
  //             "customerId": sessionStorage.getItem("userId"),
  //             "customerType": sessionStorage.getItem("permission"),
  //             "orderId": orderId
  //           },
  //           "timestamp": Date.now(),
  //           "userAgentString": navigator.userAgent,
  //           "product": {
  //             "productDetails": items.length > 1 ? items : items[0],
  //             "transactionAmount": total
  //           }
  //         },
  //         "eventInfo": {
  //           "orderSuccess": 1
  //         }
  //       });
  //     }
  //   } catch (e) {
  //     this.UTS.error(e);
  //     console.log(e);
  //   }
  //   console.log(window.adobeDataLayer);
  // }
}
